<template>
  <div class="lesson-resource">
    <a :href="resource.file" v-if="resource.file" :download="resource.file">{{resource.instruction}}</a>
    <a :href="resource.url" v-else target="_blank">{{resource.instruction}}</a>
  </div>
</template>

<script>
export default {
  props: ["resource"]
};
</script>

<style lang="less">
.lesson-resource {
  a {
    font-size: 16px;
  }
}
</style>
